import { t as e } from "../utils-DiFe-_ei.js";
import { a as t, c as n, i as r, n as i, o as a, r as o, s, t as c } from "../dist-BWsUe_id.js";
import { t as l } from "../x-DCbCFsrz.js";
import * as u from "react";
import { jsx as d, jsxs as f } from "react/jsx-runtime";
//#region src/foundations/sheet/sheet.tsx
var p = c, m = n, h = i, g = a, _ = u.forwardRef(({ className: n, ...r }, i) => /* @__PURE__ */ d(t, {
	className: e("fixed inset-0 z-50 bg-black/40 backdrop-blur-[2px]", "data-[state=open]:animate-in data-[state=closed]:animate-out", "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", n),
	...r,
	ref: i
}));
_.displayName = "SheetOverlay";
var v = {
	right: "inset-y-0 right-0 h-full w-3/4 max-w-2xl data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right",
	left: "inset-y-0 left-0 h-full w-3/4 max-w-2xl data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left",
	bottom: "inset-x-0 bottom-0 w-full max-h-[85dvh] border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom"
}, y = u.forwardRef(({ side: t = "right", className: n, children: r, ...a }, s) => /* @__PURE__ */ f(g, { children: [/* @__PURE__ */ d(_, {}), /* @__PURE__ */ f(o, {
	ref: s,
	className: e("fixed z-50 flex flex-col bg-background shadow-xl", "transition ease-in-out", "data-[state=open]:animate-in data-[state=closed]:animate-out", "data-[state=closed]:duration-200 data-[state=open]:duration-300", v[t], n),
	...a,
	children: [r, /* @__PURE__ */ f(i, {
		className: "ring-offset-background focus:ring-ring data-[state=open]:bg-secondary absolute top-4 right-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-none disabled:pointer-events-none",
		children: [/* @__PURE__ */ d(l, { className: "h-4 w-4" }), /* @__PURE__ */ d("span", {
			className: "sr-only",
			children: "Close"
		})]
	})]
})] }));
y.displayName = "SheetContent";
var b = ({ className: t, ...n }) => /* @__PURE__ */ d("div", {
	className: e("flex flex-col gap-1.5 border-b px-4 py-4", t),
	...n
});
b.displayName = "SheetHeader";
var x = u.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ d(s, {
	ref: r,
	className: e("text-lg font-semibold text-foreground", t),
	...n
}));
x.displayName = "SheetTitle";
var S = u.forwardRef(({ className: t, ...n }, i) => /* @__PURE__ */ d(r, {
	ref: i,
	className: e("text-sm text-muted-foreground", t),
	...n
}));
S.displayName = "SheetDescription";
//#endregion
export { p as Sheet, h as SheetClose, y as SheetContent, S as SheetDescription, b as SheetHeader, _ as SheetOverlay, g as SheetPortal, x as SheetTitle, m as SheetTrigger };

//# sourceMappingURL=sheet.js.map